import { render, staticRenderFns } from "./IconReporting.vue?vue&type=template&id=11855aaa&"
import script from "./IconReporting.vue?vue&type=script&lang=ts&"
export * from "./IconReporting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports